import { FC, useState } from "react";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { Button } from "components/shared";
import { DocumentAttachment } from "../../DocumentAttachment/DocumentAttachment";
import { changeChooseAll, changeChooseAllGlobal } from "toolkit/steps/stepSeven/stepSeven.slice";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import ConfirmNavigate from "components/ConfirmNavigate";
import styles from "./SelectionControl.module.sass";

export const SelectionControl: FC = () => {
	const { attachmentList, searchMode, data, searchedData } = useAppSelector((state) => state.stepSeven);
	const [modalWindow, setModalWindow] = useState<boolean>(false);
	const [confirmAction, setConfirmAction] = useState<boolean>(false);
	const [documentAttached, setDocumentAttached] = useState<boolean>(false);
	const dispatch = useAppDispatch();

	const switchSelection = (value: boolean) => {
		dispatch(changeChooseAll(value));
		dispatch(changeChooseAllGlobal(value));
	};

	const checkSelection = () => {
		if ((searchMode ? searchedData : data).repeatable.some((object) => attachmentList.includes(object.id))) {
			setConfirmAction(true);
		} else {
			setConfirmAction(false);
			setModalWindow(true);
		}
	};

	const confirmClick = () => {
		setModalWindow(true);
		setConfirmAction(false);
	};

	return (
		<>
			{modalWindow && (
				<ModalWindow close={() => setModalWindow(false)} width={documentAttached ? "" : "huge"}>
					<DocumentAttachment close={() => setModalWindow(false)} setDocumentAttached={setDocumentAttached} />
				</ModalWindow>
			)}
			<ConfirmNavigate toggle={confirmAction} close={() => setConfirmAction(false)} clickHandler={confirmClick} />

			<div data-comment-false={true} className={styles.header}>
				<div>
					<span className={styles.title}>Выберите объекты для прикрепления письма ФСТЭК</span>
					<div className={styles.managment}>
						<button onClick={() => switchSelection(true)} className={styles["managment-btn"]}>
							Выбрать всё
						</button>
						<button onClick={() => switchSelection(false)} className={styles["managment-btn"]}>
							Отменить выбор
						</button>
					</div>
				</div>
				<Button onClick={checkSelection} disabled={!attachmentList.length}>
					Прикрепить документ
				</Button>
			</div>
		</>
	);
};
